import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';

const json = {
  1: { // Exercise num
    unit: 'Unit 7',
    id: 'SB3-U7-P52-E1',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [{ url: 'img/FriendsPlus/Page52/E1/1.jpg' }],
      [{ url: 'img/FriendsPlus/Page52/E1/2.jpg' }],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 7',
    id: 'SB3-U7-P52-E2',
    audio: 'img/FriendsPlus/Page52/Audio/audio-e2-p52.mp3',
    video: '',
    component: UI,
    recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page52/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page52/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page52/Audio/tieude-e2-p52.mp3' },
        { url: 'img/FriendsPlus/Page52/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page52/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 7',
    id: 'SB3-U7-P52-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page52/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read again. Circle the false word and write the correct word.', color: "#1F4199" }],
    question: {
      Write: {
        // checkUppercase: true,
        inputStyle: { width: 200, marginLeft: 20, color: '#00a8ec' },
        answers: ['elephants', 'six', 'six', 'meat'],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {},
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', borderRadius: '50%', },
        limitSelect: 1,
        listWords: [
          'Her favorite animals are the tigers.', //1
          'There are four elephants at the zoo.', //2
          'Vy gets up at nine o’clock.', //3
          'The lions eat salad.', //4
        ],
        answers: ['0-10', '1-4', '2-8', '3-6'],
        initialValue: [],
      },
      Layout: `
        <img src="img/FriendsPlus/Page52/E3/1.jpg" style="width: 100%">
        <div style='display: flex; flex-direction: row;position: relative;'>
          <div style='flex: 3'>
            <div><b>1</b>&nbsp;Vy works at a <span style="border: 2px solid rgb(0, 168, 236);padding: 3px;border-radius: 50%;"> station</span>.</div>
            <div><b>2</b> <input id='0' type='Circle' /></div>
            <div><b>3</b> <input id='1' type='Circle' /></div>
            <div><b>4</b> <input id='2' type='Circle' /></div>
            <div><b>5</b> <input id='3' type='Circle' /></div>
          </div>
          <div style='flex: 1'>
            <div><u style='color: #00a8ec'>&emsp;zoo&emsp;</u></div>
            <div><input id='0' /></div>
            <div><input id='1' /></div>
            <div><input id='2' /></div>
            <div><input id='3' /></div>
          </div>
        </div>
      `,
    },
  },
}

export default json;